<template>
    <div class="content">
        <base-header class="pb-6 bg-gradient" type="">
            <b-row align-v="center" class="py-4">
                <b-col cols="7" lg="6">
                    <h6 class="h2 d-inline-block mb-0">
                        Trainingsvideos
                    </h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">

            <div>

                <b-row class="card-wrapper">

                    <b-col lg="3">


                        <b-card title="Video 1" img-src="/img/custom/wo_finde_ich_was_auf_der_seite.png" img-alt="Image" img-top
                            tag="article" style="max-width: 20rem;" class="mb-2">
                            <b-card-text>
                                Wo finde ich was auf der Seite
                            </b-card-text>

                            <base-button type="primary" class="btn btn-primary">
                                <span class="btn-inner--text" @click="showVideo1()">Video anzeigen</span>
                            </base-button>
                        </b-card>

                    </b-col>
                    <b-col lg="3">

                        <b-card title="Video 2" img-src="/img/custom/wie_erstelle_ich_ein_angebot_fuer_einen_pkw.png" img-alt="Image" img-top
                            tag="article" style="max-width: 20rem;" class="mb-2">
                            <b-card-text>
                                Wie erstelle ich ein Angebot für einen PKW
                            </b-card-text>

                            <base-button type="primary" class="btn btn-primary">
                                <span class="btn-inner--text" @click="showVideo2()">Video anzeigen</span>
                            </base-button>
                        </b-card>

                    </b-col>
                    <b-col lg="3">

                        <b-card title="Video 3" img-src="/img/custom/wie_erstelle_ich_einen_antrag_direkt_aus_einem_gespeicherten_angebot.png" img-alt="Image" img-top
                            tag="article" style="max-width: 20rem;" class="mb-2">
                            <b-card-text>
                                Wie erstelle ich einen Antrag direkt aus einem gespeicherten Angebot
                            </b-card-text>

                            <base-button type="primary" class="btn btn-primary">
                                <span class="btn-inner--text" @click="showVideo3()">Video anzeigen</span>
                            </base-button>
                        </b-card>

                    </b-col>
                    <b-col lg="3">

                        <b-card title="Video 4" img-src="/img/custom/wie_erstelle_ich_einen_antrag_direkt_aus_einem_angebot.png" img-alt="Image" img-top
                            tag="article" style="max-width: 20rem;" class="mb-2">
                            <b-card-text>
                                Wie erstelle ich einen Antrag direkt aus einem Angebot
                            </b-card-text>

                            <base-button type="primary" class="btn btn-primary">
                                <span class="btn-inner--text" @click="showVideo4()">Video anzeigen</span>
                            </base-button>
                        </b-card>

                    </b-col>



                </b-row>

                <b-row>
                    <b-col lg="12"><br></b-col>
                </b-row>


                <b-row>

                    <b-col lg="3">

                        <b-card title="Video 5" img-src="/img/custom/wie_erstelle_ich_eine_evb.png" img-alt="Image" img-top
                            tag="article" style="max-width: 20rem;" class="mb-2">
                            <b-card-text>
                                Wie erstelle ich eine EvB
                                <br>
                            </b-card-text>

                            <base-button type="primary" class="btn btn-primary">
                                <span class="btn-inner--text" @click="showVideo5()">Video anzeigen</span>
                            </base-button>
                        </b-card>

                    </b-col>
                    <b-col lg="3">

                        <b-card title="Video 6" img-src="/img/custom/wie_sende_ich_den_antrag_an_die_versicherung.png" img-alt="Image" img-top
                            tag="article" style="max-width: 20rem;" class="mb-2">
                            <b-card-text>
                                Wie sende ich den Antrag an die Versicherung
                            </b-card-text>

                            <base-button type="primary" class="btn btn-primary">
                                <span class="btn-inner--text" @click="showVideo6()">Video anzeigen</span>
                            </base-button>
                        </b-card>

                    </b-col>


                    <b-col lg="3">

<b-card title="Video 7" img-src="/img/custom/wie_erstelle_ich_eine_evb.png" img-alt="Image" img-top
    tag="article" style="max-width: 20rem;" class="mb-2">
    <b-card-text>
        Wie erstelle ich ein Angebot für ein Nutzfahrzeug
        <br>
    </b-card-text>

    <base-button type="primary" class="btn btn-primary">
        <span class="btn-inner--text" @click="showVideo7()">Video anzeigen</span>
    </base-button>
</b-card>

</b-col>
<b-col lg="3">

<b-card title="Video 8" img-src="/img/custom/wie_sende_ich_den_antrag_an_die_versicherung.png" img-alt="Image" img-top
    tag="article" style="max-width: 20rem;" class="mb-2">
    <b-card-text>
        Wie erstelle ich einen Antrag mit Beginn in der zukunft
    </b-card-text>

    <base-button type="primary" class="btn btn-primary">
        <span class="btn-inner--text" @click="showVideo8()">Video anzeigen</span>
    </base-button>
</b-card>

</b-col>



                   
                </b-row>


                <modal :show.sync="modals.video1" :showClose="true" modal-classes=""
                    modal-content-classes="bg-gradient-info">
                    <h6 slot="header" class="modal-title">
                        <i class="fas fa-file"></i>
                        Wo finde ich was auf der Seite
                    </h6>
                    <div class="py-3 text-center">
                        <video-player :options="videoOptions1" />
                    </div>
                    <template slot="footer">
                    </template>
                </modal>

                <modal :show.sync="modals.video2" :showClose="true" modal-classes=""
                    modal-content-classes="bg-gradient-info">
                    <h6 slot="header" class="modal-title">
                        <i class="fas fa-file"></i>
                        Wie erstelle ich ein Angebot für einen PKW
                    </h6>
                    <div class="py-3 text-center">
                        <video-player :options="videoOptions2" />
                    </div>
                    <template slot="footer">
                    </template>
                </modal>

                <modal :show.sync="modals.video3" :showClose="true" modal-classes=""
                    modal-content-classes="bg-gradient-info">
                    <h6 slot="header" class="modal-title">
                        <i class="fas fa-file"></i>
                        Wie erstelle ich einen Antrag aus einem gespeicherten Angebot
                    </h6>
                    <div class="py-3 text-center">
                        <video-player :options="videoOptions3" />
                    </div>
                    <template slot="footer">
                    </template>
                </modal>

                <modal :show.sync="modals.video4" :showClose="true" modal-classes=""
                    modal-content-classes="bg-gradient-info">
                    <h6 slot="header" class="modal-title">
                        <i class="fas fa-file"></i>
                        Wie erstelle ich direkt aus einem Angebot einen Antrag
                    </h6>
                    <div class="py-3 text-center">
                        <video-player :options="videoOptions4" />
                    </div>
                    <template slot="footer">
                    </template>
                </modal>

                <modal :show.sync="modals.video5" :showClose="true" modal-classes=""
                    modal-content-classes="bg-gradient-info">
                    <h6 slot="header" class="modal-title">
                        <i class="fas fa-file"></i>
                        Wie erstelle ich eine EvB
                    </h6>
                    <div class="py-3 text-center">
                        <video-player :options="videoOptions5" />
                    </div>
                    <template slot="footer">
                    </template>
                </modal>

                <modal :show.sync="modals.video6" :showClose="true" modal-classes=""
                    modal-content-classes="bg-gradient-info">
                    <h6 slot="header" class="modal-title">
                        <i class="fas fa-file"></i>
                        Wie sende ich den Antrag an die Versicherung
                    </h6>
                    <div class="py-3 text-center">
                        <video-player :options="videoOptions6" />
                    </div>
                    <template slot="footer">
                    </template>
                </modal>

                <modal :show.sync="modals.video7" :showClose="true" modal-classes=""
                    modal-content-classes="bg-gradient-info">
                    <h6 slot="header" class="modal-title">
                        <i class="fas fa-file"></i>
                        Wie erstelle ich ein Angebot für ein Nutzfahrzeug
                    </h6>
                    <div class="py-3 text-center">
                        <video-player :options="videoOptions7" />
                    </div>
                    <template slot="footer">
                    </template>
                </modal>

                <modal :show.sync="modals.video8" :showClose="true" modal-classes=""
                    modal-content-classes="bg-gradient-info">
                    <h6 slot="header" class="modal-title">
                        <i class="fas fa-file"></i>
                        Wie erstelle ich einen Antrag mit Beginndateum in der Zukunft
                    </h6>
                    <div class="py-3 text-center">
                        <video-player :options="videoOptions8" />
                    </div>
                    <template slot="footer">
                    </template>
                </modal>



                
            </div>
        </b-container>
    </div>
</template>
<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import {
    Table,
    TableColumn,
    Select,
    Option,
    DropdownMenu,
    DropdownItem,
    Dropdown,
} from "element-ui";
import LightTable from "../Tables/RegularTables/LightTable";
import { TablePlugin } from "bootstrap-vue";

import { TimeLine, TimeLineItem } from "@/components";
import Badge from "@/components/Badge";
import { Modal, BaseAlert } from '@/components'
import swal from 'sweetalert2';
import { Tabs, TabPane } from "@/components";

import dateUtil from "../../services/date";

import VideoPlayer from '@/components/VideoPlayer.vue';
import 'video.js/dist/video-js.css';

export default {
    components: {
        RouteBreadCrumb,
        LightTable,
        Badge,
        Modal,
        TimeLine,
        TimeLineItem,
        Tabs,
        TabPane,
        VideoPlayer,
    },
    data() {
        return {
            loading: true,
            modals: {
                video1: false,
                video2: false,
                video3: false,
                video4: false,
                video5: false,
                video6: false,
                video7: false,
                video8: false,
            },
            videoOptions1: {
                autoplay: true,controls: true,fluid: true,
                sources: [{ src: '/video/wo_finde_ich_was_auf_der_seite.mp4', type: 'video/mp4 '}]
            },
            videoOptions2: {
                autoplay: true,controls: true,fluid: true,
                sources: [{ src: '/video/wie_erstelle_ich_ein_angebot_fuer_einen_pkw.mp4', type: 'video/mp4 '}]
            },
            videoOptions3: {
                autoplay: true,controls: true,fluid: true,
                sources: [{ src: '/video/wie_erstelle_ich_einen_antrag_direkt_aus_einem_gespeicherten_angebot.mp4', type: 'video/mp4 '}]
            },
            videoOptions4: {
                autoplay: true,controls: true,fluid: true,
                sources: [{ src: '/video/wie_erstelle_ich_einen_antrag_direkt_aus_einem_angebot.mp4', type: 'video/mp4 '}]
            },
            videoOptions5: {
                autoplay: true,controls: true,fluid: true,
                sources: [{ src: '/video/wie_erstelle_ich_eine_evb.mp4', type: 'video/mp4 '}]
            },
            videoOptions6: {
                autoplay: true,controls: true,fluid: true,
                sources: [{ src: '/video/wie_sende_ich_den_antrag_an_die_versicherung.mp4', type: 'video/mp4 '}]
            },
            videoOptions7: {
                autoplay: true,controls: true,fluid: true,
                sources: [{ src: '/video/wie_erstelle_ich_ein_angebot_fuer_ein_nfz.mp4', type: 'video/mp4 '}]
            },
            videoOptions8: {
                autoplay: true,controls: true,fluid: true,
                sources: [{ src: '/video/wie_erstelle_ich_einen_antrag_mit_beginn_in_der_zukunft.mp4', type: 'video/mp4 '}]
            },
        };
    },
    methods: {

        showVideo1() {
            this.modals.video1 = true;
        },
        showVideo2() {
            this.modals.video2 = true;
        },
        showVideo3() {
            this.modals.video3 = true;
        },
        showVideo4() {
            this.modals.video4 = true;
        },
        showVideo5() {
            this.modals.video5 = true;
        },
        showVideo6() {
            this.modals.video6 = true;
        },
        showVideo7() {
            this.modals.video7 = true;
        },
        showVideo8() {
            this.modals.video8 = true;
        },
        showSwal(title, text, icon) {
            swal.fire({
                title: title,
                text: text,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-success',
                icon: icon,
                timer: 1500,
            })
        },

    },
    computed: {
    },
    mounted() {

    },
    created() { },
};
</script>
<style>
.full_modal-dialog {
    width: 98% !important;
    height: 92% !important;
    min-width: 98% !important;
    min-height: 92% !important;
    max-width: 98% !important;
    max-height: 92% !important;
    padding: 0 !important;
}

.full_modal-content {
    height: 99% !important;
    min-height: 99% !important;
    max-height: 99% !important;
}

.modal {
    padding: 20 !important;
}

.modal .modal-dialog {
    width: 100%;
    max-width: none;
    height: 100%;
    margin: 0;
}

.modal .modal-content {
    height: 100%;
    border: 0;
}

.modal .modal-body {
    overflow-y: auto;
    padding: 0 !important;
}
</style>
